import packageJson from '../../../package.json';

const defaultOptions = {
  quality: 80,
  format: 'webp',
};

/**
 * Generates a URL for the p-img service with specified options
 * @param {string} originSrc - The source image URL to be processed
 * @param {Object} [overrideOptions] - Optional parameters to override default settings
 * @param {number|string} [overrideOptions.width] - The desired width of the image
 * @param {string} [overrideOptions.format] - The output format (default: 'webp')
 * @param {number|string} [overrideOptions.quality] - The image quality (default: 80)
 * @param {boolean} [overrideOptions.mask] - Additional mask parameter
 * @returns {string} The complete p-img service URL with query parameters
 * @example
 * // Basic usage with default options
 * getPImageUrl('https://example.com/image.jpg')
 *
 * // With custom options
 * getPImageUrl('https://example.com/image.jpg', {
 *   width: 800,
 *   quality: 90,
 *   format: 'jpeg'
 * })
 */
export const getPImageUrl = (originSrc, overrideOptions) => {
  const src = btoa(
    originSrc.startsWith('/')
      ? `${process.env.NEXT_PUBLIC_DOMAIN}${originSrc}`
      : originSrc
  );
  const options = {
    ...defaultOptions,
    ...overrideOptions,
    env: process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'dev',
    hash: packageJson.version,
    src: src,
  };
  const urlSearchParams = new URLSearchParams(options);

  return `https://p-img.wwechampions.com?${urlSearchParams.toString()}`;
};
